@if (shopHeader() && headerSlimFacadeService.navSlimDetails()) {
  <idp-nav-slim-links
    [shopContent]="headerSlimFacadeService.navSlimDetails()"
    (modifyButtonClicked)="onClick($event)"
  ></idp-nav-slim-links>
}

@if (vacationHeader() && vacationHeaderFacadeService.vacationSearchContent()) {
  <idp-nav-slim-links
    [vacationContent]="vacationHeaderFacadeService.vacationSearchContent()"
    (modifyButtonClicked)="onClick($event)"
  ></idp-nav-slim-links>
}
